import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center bg-coral-500 rounded-lg">
                <i className="ri-home-smile-line text-2xl text-white"></i>
              </div>
              <span className="text-2xl font-bold text-gray-900">Aire University</span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer">
                Home
              </Link>
              <Link to="/services" className="text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer">
                Services
              </Link>
              <Link to="/gallery" className="text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer">
                Gallery
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer">
                Contact
              </Link>
              <Link
                to="/contact"
                className="bg-coral-500 text-white px-6 py-2.5 rounded-lg hover:bg-coral-600 transition-all duration-300 font-semibold whitespace-nowrap cursor-pointer"
              >
                Get Started
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-900 cursor-pointer"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white pt-20">
          <div className="flex flex-col items-center gap-6 p-8">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-xl text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-xl text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer"
            >
              Services
            </Link>
            <Link
              to="/gallery"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-xl text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer"
            >
              Gallery
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-xl text-gray-700 hover:text-coral-500 transition-colors font-medium cursor-pointer"
            >
              Contact
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="bg-coral-500 text-white px-8 py-3 rounded-lg hover:bg-coral-600 transition-all duration-300 font-semibold whitespace-nowrap cursor-pointer"
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
